import type { RecursivePartial } from '#types/utils'
import type { BenefitsConfig } from '#types/config/components/loyalty/benefits'

export default {
  brandClasses: {
    heading: 'mb-4 title-3',
  },
  iconWidth: 32,
} satisfies RecursivePartial<BenefitsConfig>
